import type { MockPersonaData } from './types';
import type { OptimizedCompletionStorage } from '@/types/lists';

// Helper functions for persona data management
export function clearPersonaData(): void {
  localStorage.removeItem('godmode_aspirations');
  localStorage.removeItem('godmode_goals');
  localStorage.removeItem('godmode_lists');
  localStorage.removeItem('godmode_list_schedules');
  localStorage.removeItem('godmode_user_profile');
  localStorage.removeItem('godmode_notification_settings');
  localStorage.removeItem('godmode_ai_config');
  localStorage.removeItem('godmode_universal_completions');
}

export function loadPersonaIntoStorage(persona: MockPersonaData): void {
  // Store each data type in localStorage
  localStorage.setItem('godmode_aspirations', JSON.stringify(persona.aspirations));
  localStorage.setItem('godmode_goals', JSON.stringify(persona.goals));
  localStorage.setItem('godmode_lists', JSON.stringify(persona.lists));
  localStorage.setItem('godmode_list_schedules', JSON.stringify(persona.schedules));
  localStorage.setItem('godmode_user_profile', JSON.stringify(persona.profile));
  localStorage.setItem('godmode_notification_settings', JSON.stringify(persona.notificationSettings));

  // Load AI configuration if provided
  if (persona.aiConfig) {
    localStorage.setItem('godmode_ai_config', JSON.stringify(persona.aiConfig));
    console.log('🤖 AI configuration loaded into localStorage');
  }

  // Generate universal completions in v2 format for complete lists
  const completions: OptimizedCompletionStorage = {
    v: 2,
    archiveThresholdDays: 30,
    lastArchiveDate: null,
    l: {}
  };

  // Use static date - completion service will find these for non-recurring lists
  const completionDate = '2024-11-20';
  const completionTimestamp = new Date('2024-11-20T00:00:00.000Z').toISOString();

  persona.lists.forEach(list => {
    if (list.status === 'complete') {
      const completedItemIds = list.items.map(item => item.id);

      completions.l[list.id] = {
        d: { [completionDate]: completedItemIds },
        u: completionTimestamp
      };

      console.log(`✅ Generated completion record for ${list.id}: ${completedItemIds.length} items`);
    }
  });

  if (Object.keys(completions.l).length > 0) {
    localStorage.setItem('godmode_universal_completions', JSON.stringify(completions));
    console.log(`📋 Universal completions loaded: ${Object.keys(completions.l).length} complete lists`);
  }

  console.log('✅ Persona data loaded into localStorage');
}
